import { BeforeCloseEventArgs, DialogComponent } from '@syncfusion/ej2-react-popups';
import { ListViewComponent, SelectEventArgs } from '@syncfusion/ej2-react-lists';
import React from 'react';
import { Circle, Marker, Popup } from 'react-leaflet';
import * as Inovx from '@shared';
import { ButtonComponent, SwitchComponent } from '@syncfusion/ej2-react-buttons';
import AssemblyLibraryActions from '../actions/AssemblyLibraryActions';
import BabylonViewer, { BabylonViewerHandle } from './BabylonViewer';
import AssemblyLibraryStore from '../stores/AssemblyLibraryStore';
import AssemblyLibraryConstants from './../constants/AssemblyLibraryConstants';
import useAsyncActionLock from '@shared/hooks/useAsyncActionLock';
const { useState, useEffect, useRef } = React;

var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var InovxControls = Inovx.Shared.Controls;
var SystemActions = Inovx.Shared.System.Actions;
var SystemStore = Inovx.Shared.System.Store;
interface formDataProps {
    Name: string
}
interface formErrorProps {
    Name: boolean
}
interface originErrorProps {
    X: boolean,
    Y: boolean,
    Z: boolean
}

const AssemblyLibrary = () => {
    const blankData: IAssemblyTemplate = {
        ID: null,
        VersionToken: null,
        Name: "",
        LibraryID: "",
        Scalable: false,
        GraphicsFileUrl: "",
        ThumbnailImageUrl: "",
        Scale: 1,
        Origin: {X: 0, Y: 0, Z: 0}
    }
    const [isModalOpen, setModalOpen] = useState<boolean>(false);
    const [isAncherModalOpen, setAnchorModalOpen] = useState<boolean>(false);    
    const [formErrors, setFormErrors] = useState<formErrorProps>({ Name: false});
    const [formData, setFormData] = useState<formDataProps>({ Name: "" });
    const [originFormErrors, setOriginFormErrors] = useState<originErrorProps>({ X: false, Y: false, Z: false });
    const [originForm, setOriginForm] = useState<IVector3D>({ X: 0, Y: 0, Z: 0 });
    const [templateFormData, setTemplateFormData] = useState<IAssemblyTemplate>(null);
    const [templateFormErrors, setTemplateFormErrors] = useState<IAssemblyTemplateFormErrorProps>(AssemblyLibraryStore.getValidation());
    const [assembleyLibraries, setAssembleyLibraries] = useState<IAssemblyLibrary[]>([]);
    const [selectedAssemblyLibrary, setSelectedAssemblyLibrary] = useState<string>('');
    const [selectedAssemblyTemplates, setSelectedAssemblyTemplates] = useState<IAssemblyTemplate[]>([]);
    const [isUploadEnable, setUploadEnable] = useState<boolean>(false);
    const [isActionInProgress, setActionInProgress] = useState<boolean>(false);
    const [isDeleteInProgress, setDeleteInProgress] = useState<boolean>(false);
    const babylonViewerRef = useRef<BabylonViewerHandle>(null);
    const [isNewGLBUploaded, setNewGLBUploaded] = useState(false);
    const [hasChanges, setHasChanges] = useState(AssemblyLibraryStore.getHasAssemblyTemplateChange());

    const getIsActionInProgress = ()=> {
        return SystemStore.isActionInProgress(AssemblyLibraryConstants.ASSEMBLY_LIBRARY_TEMPLATE_ADD) ||
            SystemStore.isActionInProgress(AssemblyLibraryConstants.ASSEMBLY_LIBRARY_TEMPLATE_UPDATE) ||
            SystemStore.isActionInProgress(AssemblyLibraryConstants.ASSEMBLY_LIBRARY_TEMPLATE_DELETE);
    }
    const systemChange = () => {
        setActionInProgress(getIsActionInProgress())
        setDeleteInProgress(SystemStore.isActionInProgress(AssemblyLibraryConstants.ASSEMBLY_LIBRARY_TEMPLATE_DELETE))
    }
    const assemblyChange = () => {
        setSelectedAssemblyTemplates(AssemblyLibraryStore.getAssemblyTemplates())
        setTemplateFormData(AssemblyLibraryStore.getAssemblyTemplateData())
        setTemplateFormErrors(AssemblyLibraryStore.getValidation());
        setSelectedAssemblyLibrary(AssemblyLibraryStore.getSelectedAssemblyLibraryId());
        setHasChanges(AssemblyLibraryStore.getHasAssemblyTemplateChange());
        setAssembleyLibraries(AssemblyLibraryStore.getAssemblyLibraries());
    }
    const getAssemblyLibraries= async () => {
        let data = await AssemblyLibraryActions.getAssemblyLibraries();
        data.sort((a, b) => a.Name.localeCompare(b.Name));
        setAssembleyLibraries(data);
    }
    const updateBoxHeight = () => {
        const windowHeight = window.innerHeight;
        const divElement = document.getElementById('assemblyBox');
        if (divElement) {
            let divHeight = windowHeight - 290;
            divElement.style.height = `${divHeight}px`;
        }
        const divElement2 = document.getElementById('boxHeight');
        if (divElement2) {
            let divHeight2 = windowHeight - 497;
            divElement2.style.height = `${divHeight2}px`;
        }
    }
    const checkForUnsavedChanges = (event: any) => {
        if (AssemblyLibraryStore.getHasAssemblyTemplateChange()) { // can't reference state here
            event.returnValue = InovxLoader.t("common:msgBox.browserSaveChanges");
        };
    }

    useEffect(() => {
        const handleResize = () => {
            updateBoxHeight();
        };
        window.addEventListener("resize", handleResize);
        SystemStore.addChangeListener(systemChange);
        AssemblyLibraryStore.addChangeListener(assemblyChange);
        getAssemblyLibraries()
        window.addEventListener('beforeunload', checkForUnsavedChanges);
        return () => {
            SystemStore.removeChangeListener(systemChange);
            AssemblyLibraryStore.removeChangeListener(assemblyChange);
            window.removeEventListener("resize", handleResize);
            window.removeEventListener('beforeunload', checkForUnsavedChanges);
        };
    }, [])

    const getAssemblyTemplates = async (LibraryID: string) => {
        if (LibraryID) {
            await AssemblyLibraryActions.getAssemblyTemplates(LibraryID);
        }
    }
    const openAssemblyTemplate = (data: IAssemblyTemplate) => {
        if (!AssemblyLibraryActions.verifyAssemblyTemplateChanges()) {
            return;
        }

        data.LibraryID = selectedAssemblyLibrary;
        setOriginForm(data.Origin);
        setUploadEnable(false)
        setTimeout(() => {
            setUploadEnable(true)
            AssemblyLibraryActions.setAssemblyTemplateData(data);
        });
    }
    useEffect(() => {
        setTimeout(() => {
            AssemblyLibraryActions.setAssemblyTemplateData(null);
            getAssemblyTemplates(selectedAssemblyLibrary);
        });
    }, [selectedAssemblyLibrary]);

    const changeAssemblyLibrary = (id: string) => {
        if (!AssemblyLibraryActions.verifyAssemblyTemplateChanges()) {
            return;
        }

        AssemblyLibraryActions.setSelectedAssemblyLibrary(id);
    }

    const resetAssemblyLibrary = () => {
        AssemblyLibraryActions.resetAssemblyTemplate();
    }
    const confirmDeleteAssemblyTemplate = () => {
        if (!templateFormData?.ID) return;

        SystemActions.displayConfirmationMessage({
            message: InovxLoader.t("facility:message.confirmAssemblyTemplateDeletion"),
            confirmCallback: async () => {
                await AssemblyLibraryActions.deleteAssemblyTemplate(templateFormData);
            }
        });
    }
    const confirmDeleteAssemblyLibrary = () => {
        if (!selectedAssemblyLibrary) return;

        const selectedLibrary = assembleyLibraries.find(lib => lib.ID === selectedAssemblyLibrary);
        if (!selectedLibrary) return;

        if (!AssemblyLibraryActions.verifyAssemblyTemplateChanges()) {
            return;
        }

        // Check if library has any templates
        if (selectedAssemblyTemplates && selectedAssemblyTemplates.length > 0) {
            SystemActions.displayErrorMessage({
                message: InovxLoader.t("facility:message.assemblyLibraryNotEmpty")
            });
            return;
        }

        SystemActions.displayConfirmationMessage({
            message: InovxLoader.t("facility:message.confirmAssemblyLibraryDeletion"),
            confirmCallback: async () => {
                await AssemblyLibraryActions.deleteAssemblyLibrary(selectedLibrary);
            }
        });
    }
    const isFormValid = () => {
        let errors = { ...formErrors };
        let flag = true;
        if (!formData.Name) {
            flag = false;
            errors.Name = true;
        } else {
            errors.Name = false;
        }
        setFormErrors(errors)
        return flag;
    }
    const updateThumbnailAndGLB = async () => {
        if (babylonViewerRef.current) {
            let ThumbnailImageData, GraphicsFileData = null;
            const thumbnail = await babylonViewerRef.current.generateThumbnail();
            if (thumbnail) {
                let imgArray = thumbnail.split(',')
                if (imgArray.length > 0) {
                    let thumbImage = imgArray[1];
                    const byteCharacters = atob(thumbImage);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: 'image/png' });
                    ThumbnailImageData = blob;
                }
                AssemblyLibraryActions.editAssemblyTemplateProperty('ThumbnailImageData', ThumbnailImageData);

                const glb = await babylonViewerRef.current.generateSceneGLB();
                if (glb) {
                    const blob = new Blob([glb as any], { type: 'application/octet-stream' });
                    if (blob) GraphicsFileData = blob;

                    AssemblyLibraryActions.editAssemblyTemplateProperty('GraphicsFileData', GraphicsFileData);
                }
            }
            return true;
        }
        return false;
    };
    
    const handleImageLoaded = async () => {
        setNewGLBUploaded(true);
    }
    const createAssemblyLibrary = async () => {
        const isValid = isFormValid();
        if (!isValid) return;
        
        const params: IAssemblyLibrary = {
            ID: null,
            VersionToken: null,
            Name: formData.Name
        }
        const newLibrary = await AssemblyLibraryActions.createAssemblyLibrary(params);
        setFormData({ Name: '' })
        setModalOpen(false)
        await getAssemblyLibraries()
        if (newLibrary?.ID) {
            AssemblyLibraryActions.setSelectedAssemblyLibrary(newLibrary.ID);
        }
    }
    const saveAssemblyTemplate = async () => {
        if (isNewGLBUploaded) await updateThumbnailAndGLB();
        if (templateFormData.ID) {
            await AssemblyLibraryActions.updateAssemblyTemplate();
        } else {
            await AssemblyLibraryActions.createAssemblyTemplate();
        }
        setNewGLBUploaded(false)
    }
   
    const enableUpload = () => {
        setUploadEnable(false);
        setTimeout(() => {
            setUploadEnable(true)
        }, 10)
    }

    const handleInputChange = (e: any) => {
        const form: any = { ...formData };
        form[e.target.name] = e.target.value;
        setFormData(form)
    }
    const handleTemplateInputChange = (e: any) => {
        const { name, value } = e.target;
        if (name === 'Scale') {
            const decimalPattern = /^\d*\.?\d*$/;
            if (decimalPattern.test(value)) {
                AssemblyLibraryActions.editAssemblyTemplateProperty(name, value);
                const numericValue = parseFloat(value);
                if (numericValue > 0) AssemblyLibraryActions.setAssemblyScale(value)
            }
        } else {
            AssemblyLibraryActions.editAssemblyTemplateProperty(name, value); 
        }
    }
    const handleSwitchChange = (e: any) => {
        AssemblyLibraryActions.editAssemblyTemplateProperty(e.target.name, e.target.checked); 
    };

    //origin modal
    const openOriginModal = () => {
        setOriginForm(templateFormData.Origin)
        setAnchorModalOpen(true);
    }
    const handleOriginInputChange = (e: any) => {
        const form: any = { ...originForm };
        const { name, value } = e.target;
        const decimalPattern = /^[-+]?\d*\.?\d*$/;
        if (decimalPattern.test(value)) {
            form[name] = value;
            setOriginForm(form)
        }
    }
    const isOriginFormValid = () => {
        let errors = { ...originFormErrors };
        let flag = true;
        ['X', 'Y', 'Z'].forEach((key) => {
            let value:any = originForm[key as keyof typeof originForm];
            value = value === '' ? '' : parseFloat(value);
            if (typeof value === 'string' || value === null || value === undefined || isNaN(value)) {
                flag = false;
                errors[key as keyof typeof errors] = true;
            } else {
                errors[key as keyof typeof errors] = false;
            }
        });
        setOriginFormErrors(errors)
        return flag;
    }
    const saveAssemblyOrigin = () => { 
        if (isOriginFormValid()) {
            const origins: any = { ...originForm };
            AssemblyLibraryActions.editAssemblyTemplateProperty('Origin', origins);
            setAnchorModalOpen(false);
        }
    }

    const createLibraryAction = useAsyncActionLock(createAssemblyLibrary);
    const saveTemplateAction = useAsyncActionLock(saveAssemblyTemplate);

    useEffect(() => {
        updateBoxHeight();
        const loadGLB = async () => {
            if (templateFormData?.GraphicsFileUrl && babylonViewerRef.current) {
                await babylonViewerRef.current.loadGLBIntoScene(templateFormData.ID, templateFormData.GraphicsFileUrl);
            }
        };

        loadGLB();
    }, [templateFormData])
    const listTemplate = (data: { title: string, id: string }) => {
        return (<div className={`mb-2 list-item ${templateFormData && data.id === templateFormData.ID ? 'active-item' : ''}`}>{data.title}</div>);
    };
    const header = () => {
        return (<div>
            <div className="e-icon-settings dlg-template">{InovxLoader.t('facility:form.createAssemblyLibrary')}</div>
        </div>);
    }
    const handleSelect = (args: SelectEventArgs) => {
        const selectedData = args.data as { id: string; title: string };
        let temp = selectedAssemblyTemplates.find((item) => item.ID === selectedData.id);
        if (temp) openAssemblyTemplate(temp)
    };
    const footerTemplate = () => {
        return (<div>
            <div className="d-flex j-cc pb-10px">
                <div>
                    <a id="facilityApp-save-btn" aria-disabled={createLibraryAction.isInFlight} onClick={createLibraryAction.isInFlight ? undefined : () => void createLibraryAction.run()} className={`btn btn-primary${createLibraryAction.isInFlight ? ' disabled' : ''}`}>{InovxLoader.t("facility:preferences.saveButton")}</a>
                </div>
                <div className="ml-1"> 
                    <a id="facilityApp-cancel-btn" aria-disabled={createLibraryAction.isInFlight} onClick={createLibraryAction.isInFlight ? undefined : () => setModalOpen(false)} className={`btn btn-default${createLibraryAction.isInFlight ? ' disabled' : ''}`}>{InovxLoader.t("facility:preferences.cancelButton")}</a>
                </div>
            </div>
        </div>);
    }

    const anchorHeader = () => {
        return (<div>
            <div className="e-icon-settings dlg-template">{InovxLoader.t('facility:form.anchorPoints')}</div>
        </div>);
    }
    const anchorFooterTemplate = () => {
        return (<div>
            <div className="d-flex j-cc pb-10px">
                <div>
                    <a id="facilityApp-save-btn" onClick={() => saveAssemblyOrigin()} className="btn btn-primary ">{InovxLoader.t("facility:preferences.saveButton")}</a>
                </div>
                <div className="ml-1">
                    <a id="facilityApp-cancel-btn" onClick={() => setAnchorModalOpen(false)} className="btn btn-default">{InovxLoader.t("facility:preferences.cancelButton")}</a>
                </div>
            </div>
        </div>);
    }

    return (
        <div className={`assembly-library show`} id="assembly-library-content">
            <div className="row-padding text-black">{InovxLoader.t('facility:menu.assemblyLibrary')}</div>
            <div className="d-flex a-ic row-padding mt-1">
                <button onClick={() => setModalOpen(true)} className="btn-flat text-primary d-flex a-ic">
                    <img className="icon mr-10px" src={`${UrlUtilities.getBaseApplicationUrl()}/images/icons/add.png`} /> {InovxLoader.t('facility:form.addLibrary')}</button>
            </div>
            <div className="d-flex a-ic row-padding">
                <div className="col-md-4" style={{paddingLeft: 0, paddingRight: 0}}>
                    <select className="form-control" value={selectedAssemblyLibrary || ''} onChange={(e) => changeAssemblyLibrary(e.target.value)}>
                        <option value="">{InovxLoader.t('facility:form.selectAssemblyLibrary')}</option>
                        {assembleyLibraries.map((item) => <option key={item.ID} value={item.ID}>{item.Name}</option>)}
                    </select>
                </div>
                {selectedAssemblyLibrary && (
                    <div className="ml-1">
                        <a className="btn btn-danger" onClick={confirmDeleteAssemblyLibrary}>{InovxLoader.t('facility:form.deleteLibrary')}</a>
                    </div>
                )}
            </div>
            <hr />
            {selectedAssemblyLibrary && <>
                <div className="d-flex j-csb row-padding">
                    <div className="d-flex a-ic">
                        <button className="btn-flat text-primary d-flex a-ic" onClick={() => openAssemblyTemplate(blankData)}>
                            <img className="icon mr-10px" src={`${UrlUtilities.getBaseApplicationUrl()}/images/icons/add.png`} /> {InovxLoader.t('facility:form.addAssembly')}</button>
                    </div>
                    <div>
                        {templateFormData && <div className="d-flex a-ic">
                            {isActionInProgress && <div className="message mr-5px">{isDeleteInProgress ? InovxLoader.t('facility:form.deleting') : InovxLoader.t('facility:form.saving')}</div>}
                            <a aria-disabled={saveTemplateAction.isInFlight} className={`btn btn-primary mr-15p ${hasChanges && !saveTemplateAction.isInFlight ? '' : 'disabled'}`} onClick={hasChanges && !saveTemplateAction.isInFlight ? () => void saveTemplateAction.run() : undefined}>{InovxLoader.t('facility:preferences.saveButton')}</a>
                            <a className={`btn btn-default ${hasChanges ? '' : 'disabled'}`} onClick={resetAssemblyLibrary}>{InovxLoader.t('facility:preferences.resetButton')}</a>
                            <a className={`btn btn-danger ml-1 ${templateFormData?.ID ? '' : 'disabled'}`} onClick={confirmDeleteAssemblyTemplate}>{InovxLoader.t('facility:form.delete')}</a>
                        </div>}
                    </div>

                </div>

                <div className="row box-padding h-55vh mt-1" id="assemblyBox">
                    <div className="col-md-4 border-box">
                        <div className="list-title">{InovxLoader.t('facility:menu.assemblies')}</div>
                        <div className="list-container ctm-scroller">
                            <ListViewComponent id='listview_template'
                                dataSource={selectedAssemblyTemplates.map((item) => ({ id: item.ID, title: item.Name }))}
                                cssClass='e-list-template' template={listTemplate as any} select={handleSelect}></ListViewComponent>
                        </div>
                    </div>
                    <div className="col-md-8 h-100p">
                        {templateFormData && <>
                            <div className="row d-flex">
                                <div className="col-md-12 field-col">
                                    <InovxControls.FormField title={InovxLoader.t('facility:form.assembly')} className={templateFormErrors.Name ? 'has-error' : ''} inputName='name'>
                                        <input type="text" className="form-control" onChange={handleTemplateInputChange} value={templateFormData.Name} placeholder={InovxLoader.t('facility:form.assemblyNamePlaceholder')} name='Name' />
                                    </InovxControls.FormField>
                                </div>
                            </div>
                            <div className="row mt-1">
                                <div className="col-md-12 field-col d-flex j-csb">
                                    <div className="d-flex a-ic p-2">
                                        <SwitchComponent id="checked" checked={templateFormData.Scalable} onChange={handleSwitchChange} name="Scalable"></SwitchComponent>
                                        <label className="text-black ml-10p" htmlFor="checked"> {InovxLoader.t('facility:form.canScaleAssemblyInstance')}</label>
                                    </div>
                                    <div className="d-flex a-ic">
                                        <button title={InovxLoader.t('facility:form.position')} className="btn-flat a-ic mr-10px" onClick={() => openOriginModal()}>
                                            <img className="icon" src={`${UrlUtilities.getBaseApplicationUrl()}/images/icons/focus-blue.png`} /></button>
                                        <button title={InovxLoader.t('facility:form.upload')} className="btn-flat a-ic" onClick={() => babylonViewerRef.current.handleFileUploadClick()}>
                                            <img className="icon" src={`${UrlUtilities.getBaseApplicationUrl()}/images/icons/upload-blue.png`} /></button>
                                    </div>

                                </div>
                            </div>
                            <div className="row mt-1" id="boxHeight">
                                <div className="col-md-12 field-col h-100p">
                                    <div className={`upload-btn-box d-flex j-cc a-ic ${templateFormErrors.GLB ? 'has-error' : ''}`}>
                                        {isUploadEnable && <BabylonViewer ref={babylonViewerRef} onImageLoaded={handleImageLoaded} />}
                                    </div>
                                </div>
                            </div>
                            <div className="row d-flex mt-1">
                                <div className="col-md-12 field-col">
                                    <InovxControls.FormField title={InovxLoader.t('facility:form.assemblyScale')} className={`${templateFormErrors.Scale ? 'has-error' : ''} d-flex a-ic`} inputName='Scale'>
                                        <input type="text" className="form-control w-50" onChange={handleTemplateInputChange} value={templateFormData.Scale} placeholder={InovxLoader.t('facility:form.scale')} name='Scale' />
                                    </InovxControls.FormField>
                                </div>
                            </div>
                        </>}
                    </div>
                </div>
            </>}
            
            {/* Create Assembly Library dialog */}
            {isModalOpen && <DialogComponent target={'#app'} width='350px' header={() => header()} footerTemplate={() => footerTemplate()} showCloseIcon={true} visible={true} close={() => setModalOpen(false)} isModal={true} zIndex={110000}>
                <div className="dialogContent">
                    <InovxControls.FormField title={InovxLoader.t('facility:form.name2')} inputName='Name' className={formErrors.Name ? 'has-error' : ''}>
                        <input type="text" onChange={handleInputChange} value={formData.Name} className="form-control" name="Name" placeholder={InovxLoader.t('facility:form.namePlaceholder')} autoComplete="off" />
                    </InovxControls.FormField>
                </div>
            </DialogComponent>}
            {/* End Create Assembly Library dialog */}
            {/* Assembly Library anchor points dialog */}
            {isAncherModalOpen && <DialogComponent target={'#app'} width='350px' header={() => anchorHeader()} footerTemplate={() => anchorFooterTemplate()} showCloseIcon={true} visible={true} close={() => setAnchorModalOpen(false)} isModal={true} zIndex={110000}>
                <div className="dialogContent">
                    <InovxControls.FormField title={InovxLoader.t('facility:form.originX')} inputName='X' className={originFormErrors.X ? 'has-error' : ''}>
                        <input type="text" onChange={handleOriginInputChange} value={originForm.X} className="form-control" name="X" placeholder={InovxLoader.t('facility:form.enterOriginX')} autoComplete="off" />
                    </InovxControls.FormField>
                    <InovxControls.FormField title={InovxLoader.t('facility:form.originY')} inputName='Y' className={originFormErrors.Y ? 'has-error' : ''}>
                        <input type="text" onChange={handleOriginInputChange} value={originForm.Y} className="form-control" name="Y" placeholder={InovxLoader.t('facility:form.enterOriginY')} autoComplete="off" />
                    </InovxControls.FormField>
                    <InovxControls.FormField title={InovxLoader.t('facility:form.originZ')} inputName='Z' className={originFormErrors.Z ? 'has-error' : ''}>
                        <input type="text" onChange={handleOriginInputChange} value={originForm.Z} className="form-control" name="Z" placeholder={InovxLoader.t('facility:form.enterOriginZ')} autoComplete="off" />
                    </InovxControls.FormField>
                </div>
            </DialogComponent>}
            {/* End Assembly Library anchor points dialog */}

        </div>
    )
};

export default AssemblyLibrary;
